import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BaseChartDirective } from 'ng2-charts';

import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AdminAnalyticsRoutingModule } from './admin-analytics-routing.module';
import { AdminAnalyticsComponent } from './admin-analytics.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdminAnalyticsRoutingModule,
    NgxDatatableModule,
    BaseChartDirective,
    SharedPipesModule,
  ],
  declarations: [AdminAnalyticsComponent],
})
export class AdminAnalyticsModule {}
